'use es6';

import makeKnownOptionResolver from './makeKnownOptionResolver';
import privacyConsentOptions from './options/privacyConsentOptions';
export default makeKnownOptionResolver(privacyConsentOptions);